( function( global, $ ) {
    "use strict";

    var _events = {
        onChangePerson: function() {
            var $personInput = $(this),
                $formEntry = $personInput.closest('[data-form-entry="booking-contact"]'),
                $phoneInput = $formEntry.find('[data-form-control="phone"]'),
                personValue = $personInput.val();

            if (personValue === '' || $phoneInput.val() !== '') {
                return;
            }

            var defaultPhone = this.selectize
                ? this.selectize.options[personValue]['default-phone']
                : $personInput.find(':selected').data('data')['default-phone'];

            if (defaultPhone) {
                $phoneInput.val(defaultPhone);
            }
        }
    };

    var $body = $('body');

    $body.on('app.init', function(ev) {
        var $container = $(ev.container),
            $formEntries = $container.find('form [data-form-entry="booking-contact"]'),
            $personInputs = $formEntries.find('[data-form-control="person"]'),
            $phoneInputs = $formEntries.find('[data-form-control="phone"]');

        $personInputs.on('change', _events.onChangePerson);
    });

}( window.groots, jQuery ));
